<template>
  <div>
    <v-header :title="title" :rightTitle="rightTitle" @0n-add="goAdd()"></v-header>
    <div class="verifyArea">
      <div class="formContent nameContent">
        <div class="form phone">
          <label>姓名</label>
          <input type="text" placeholder="请输入您的真实姓名" v-model="compatName">
        </div>
        <div class="form verifyCode">
          <label>身份证号</label>
          <input type="text" placeholder="请输入您的身份证号" v-model="compatIdcard">
        </div>
      </div>
      <div class="formContent">
        <div class="form phone">
          <label>手机号</label>
          <input type="number" placeholder="请输入真实的手机号" v-model="compatMobile">
          <img src="../../../static/img/u691.png" alt="" @click="showInfo()">
        </div>
        <div class="form verifyCode">
          <label>验证码</label>
          <input type="number" placeholder="请输入验证码" v-model="captcha">
          <button @click="getCode()" v-if="countdown == 60 || countdown == 0">获取验证码</button>
          <button v-else>{{ countdown }}s后重新获取</button>
        </div>
      </div>
    </div>
    <alert v-show="infoDisplay" @on-iKnow="iKnow()" :firstLine="firstLine" :secondLine="secondLine"
           :bottomLine="bottomLine"></alert>
    <alert v-show="showAlert" @on-iKnow="iKnow()" :firstLine="alertContent" :secondLine="alertSecond"
           :bottomLine="bottomLine"></alert>
    <div class="verifyCenter" v-if="showVerify">
      <verify :verifyTips="verifyTips"></verify>
    </div>
    <msg ref="msg"></msg>
  </div>
</template>
<script>
import header from '../../base/header'
import Alert from '../../base/alert'
import verify from '../../base/verify'
import weui from 'weui.js'
import {tokenCache} from '../../lib/cache'
import api from '../../lib/api'
import Msg from "../../plugins/msg.vue"

export default {
  data() {
    return {
      title: "添加就诊人",
      rightTitle: "下一步",
      firstLine: "若该患者曾前往浙二就诊过，最好填写在浙二留的手机号",
      secondLine: "若该手机号不再使用，可以前往医院修改，或者直接填写真实的本人使用的手机号",
      bottomLine: "知道了",
      infoDisplay: false,
      alertContent: "",
      alertSecond: "",
      showAlert: false,
      compatName: "",
      compatIdcard: "",
      compatMobile: "",
      captcha: "",
      cid: 0,
      countdown: 60,
      a: "",
      showVerify: false,
      verifyTips: "手机号不能为空"
    }
  },
  mounted() {
  },
  methods: {
    showInfo() {
      this.infoDisplay = true
    },
    iKnow() {
      this.infoDisplay = false
      this.showAlert = false
    },
    async getCode() {
      if (this.compatMobile == '') {
        this.$refs.msg.show("手机号不能为空");
        return
      }
      let loading = weui.loading('加载中...')
      let data = await api("nethos.system.captcha.commpat.add", {
        mobile: this.compatMobile
      })
      loading.hide()
      if (data.code == 0) {
        this.cid = data.obj.cid
        this.a = setInterval(() => {
          this.countdown--
        }, 1000)
        console.log(data)
      } else if (!(data.msg)) {
        weui.alert("网络错误，请稍后重试")
        console.log(data)
      } else {
        weui.alert(data.msg)
      }
    },
    goAdd() {
      console.log(this.cid)
      if (this.compatName == '') {
        this.showVerify = true
        this.verifyTips = "姓名不能为空"
        setTimeout(() => {
          this.showVerify = false
        }, 1000)
      } else if (this.compatIdcard == '') {
        this.showVerify = true
        this.verifyTips = "身份证号不能为空"
        setTimeout(() => {
          this.showVerify = false
        }, 1000)
      } else {
        let loading = weui.loading('加载中...')
        api("nethos.system.captcha.checkcaptcha.v2", {
          captcha: this.captcha,
          cid: this.cid,
        }).then((data) => {
          console.log(data)
          if (data.code == 0) {
            api("nethos.pat.compat.add.v2", {
              compatName: this.compatName,
              compatIdcard: this.compatIdcard,
              cid: this.cid,
              captcha: this.captcha
            }).then((data) => {
              loading.hide();
              const {query} = this.$route;
              if (data.code == 0) {
                if (query && query.callback) {
                  this.$router.push(query.callback)
                } else this.$router.push('/usualPatient')
              } else if (!(data.msg)) {
                weui.alert("网络错误，请稍后重试")
              } else {
                weui.alert(data.msg)
              }
            })
              .catch(e => {
                loading.hide();
              })
          } else if (!(data.msg)) {
            loading.hide();
            weui.alert("网络错误，请稍后重试")
          } else {
            loading.hide();
            weui.alert(data.msg)
          }
        })
          .catch(() => {
            loading.hide();
          })

      }

    }
  },
  components: {
    "VHeader": header,
    Alert,
    verify,
    Msg
  },
  watch: {
    countdown() {
      if (this.countdown == 0) {
        clearInterval(this.a)
        this.countdown = 60
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '../../common/public.scss';

.verifyCenter {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.verifyArea {
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
}

.formContent {
  width: 690rem/$rem;
  margin: 0 auto;
  margin-top: 10px;

  .form {
    width: 100%;
    height: 90rem/$rem;
    line-height: 90rem/$rem;
    background-color: white;
    display: flex;
    margin-top: 1px;

    label {
      flex: 0 0 auto;
      width: 100px;
      padding-left: 1rem;
      font-size: 32rem/$rem;
      color: #333333;
      background-color: $bgColor2;
    }

    input {
      flex: 1 1 auto;
      border: none;
      outline: medium;
      font-size: 32rem/$rem;
      color: #999999;
      background-color: $bgColor2;
    }
  }

  .phone {
    /*margin-top: 20px;*/
  }

  .verifyCode, .phone {
    position: relative;
  }

  .verifyCode button {
    position: absolute;
    top: 13rem/$rem;
    right: 0;
    height: 70rem/$rem;
    line-height: 70rem/$rem;
    width: 220rem/$rem;
    border: none;
    border-radius: 7px;
    outline: medium;
    font-size: 32rem/$rem;
    color: white;
    background-color: $mainColor;
  }

  .phone img {
    position: absolute;
    top: 5px;
    right: 15rem/$rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my/addUsualPatient.vue